import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { PASSWORD_REGEX } from "@circle-react/components/OnboardingPage/helpers/constants";
import { CheckoutForm } from "@circle-react/components/Paywalls/Checkout/CheckoutV2/CheckoutForm";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { CheckoutFormField } from "../../CheckoutFormField";

export const CheckoutFormPasswordField = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { watch } = useFormContext();

  const passwordValue = watch("password");

  useEffect(() => {
    if (!passwordValue) setIsPasswordVisible(false);
  }, [passwordValue]);

  const iconType = !passwordValue
    ? "16-eye-visible"
    : isPasswordVisible
      ? "16-eye-hidden"
      : "16-eye-visible";

  return (
    <CheckoutForm.Item name="password">
      <div className="relative flex items-center">
        <CheckoutFormField
          type={isPasswordVisible && passwordValue ? "text" : "password"}
          name="password"
          options={{
            required: true,
            pattern: PASSWORD_REGEX,
          }}
          className="w-full"
        />
        <Button
          variant="text"
          type="button"
          className={classNames(
            "absolute right-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center focus:outline-none",
            passwordValue
              ? "cursor-pointer text-neutral-600 hover:text-neutral-800"
              : "cursor-not-allowed text-neutral-400",
          )}
          onClick={
            passwordValue
              ? () => setIsPasswordVisible(prev => !prev)
              : undefined
          }
          tabIndex={passwordValue ? 0 : -1}
          disabled={!passwordValue}
          onKeyDown={e => {
            if (passwordValue && ["Enter", " "].includes(e.key)) {
              setIsPasswordVisible(prev => !prev);
              e.preventDefault();
            }
          }}
        >
          <Icon type={iconType} className="h-4" />
        </Button>
      </div>
    </CheckoutForm.Item>
  );
};
